import { useCallback } from 'react';
import { useNavigate } from '@tanstack/react-router';
import toast from 'react-hot-toast';
import { authApi, type LoginPayload } from '@/api/auth.api';
import { useAuthStore } from '@/stores/auth.store';
import { disconnectSocket } from '@/sockets/socket';

export function useAuth() {
  const navigate = useNavigate();
  const { user, token, isAuthenticated, setSession, logout: clearSession } = useAuthStore();

  const login = useCallback(
    async (payload: LoginPayload) => {
      try {
        const result = await authApi.login(payload);
        setSession(result);
        toast.success(`Bienvenido, ${result.user.display_name || result.user.username}`);
        navigate({ to: '/chats' });
        return result;
      } catch (err) {
        const msg = err instanceof Error ? err.message : 'Error de autenticación';
        toast.error(msg);
        throw err;
      }
    },
    [navigate, setSession],
  );

  const logout = useCallback(async () => {
    try {
      await authApi.logout();
    } finally {
      disconnectSocket();
      clearSession();
      navigate({ to: '/login' });
      toast.success('Sesión cerrada');
    }
  }, [clearSession, navigate]);

  return { user, token, isAuthenticated, login, logout };
}
